import { render, staticRenderFns } from "./SuccessComponent.vue?vue&type=template&id=fafd21c4&"
import script from "./SuccessComponent.vue?vue&type=script&lang=js&"
export * from "./SuccessComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports